/** APIの窓口を画面へ配る入れ物（画面は `useApi()` で受け取る）。 */
import { createContext, useContext } from 'react';
import type { ApiClient } from './client.js';

export const ApiContext = createContext<ApiClient | null>(null);

export function useApi(): ApiClient {
  const client = useContext(ApiContext);
  if (!client) {
    // 組み立ての誤り（本番では起きない）。黙って動かず、その場で分かるようにする
    throw new Error('APIの窓口が用意されていません');
  }
  return client;
}
